import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {environment} from '../../environments/environment';
import {Event} from '../model/Event';
import {CommonService} from './common.service';

@Injectable({
  providedIn: 'root'
})
export class EventService extends CommonService<Event> {

  constructor(http: HttpClient) {
    super(http, '/events');
  }

  getEvent(): Observable<Event> {
    return this.http.get<Event>(`${environment.backend}/events`);
  }
}
